import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/shared/services/common.service';
import { UtilService } from 'src/app/shared/services/util.service';
import { FormControl, FormGroup } from '@angular/forms';
import { BaseFormGroup } from 'src/app/shared/form-input-components/base-form-group';
import { BillingReportsService } from './billing-reports.service';
import { CommonBillingService } from '../shared/common-billing.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { HttpEventType } from '@angular/common/http';
import { parseZone } from 'moment';

@Component({
  selector: 'app-billing-reports',
  templateUrl: './billing-reports.component.html',
  styleUrls: ['./billing-reports.component.scss']
})
export class BillingReportsComponent extends BaseFormGroup implements OnInit {

  public startDate: any;
  public endDate: any;
  public inputControlStartDate: any;
  public inputControlEndDate: any;
  public config: any;
  public formDetails: FormGroup;
  public filterSectionConfig: any;
  public dateSectionConfig: any;
  public filterElementConfig = {};
  public fileToUpload: any;
  public showFileUploaddModal: boolean;
  public showFileUploadModal: boolean;
  public uploadFileError: any;
  public fileName = '';
  public isLoading = false;
  public showUploadSuccess = false;
  public vendors: any;
  public cabs: any;
  public costCenters: any;
  public vendorOptions: any;
  public cabOptions: any;
  public costCenterOptions: any;
  public officesOptions: any;
  public offices: any;
  public configToValueMap: any;
  public lastUploadedFile: any;
  public lastUploadedFileName: any;
  public dateMaxConfig: any;
  public showErrorDialog = false;
  public errorMessage: string;
  public displayInvalidDateError = false;
  public displayInvalidDateMessage: string;
  showFileErrors = false;
  failedRows = [];
  showSuccessToast = false;
  successMessage = "";
  vendorMap = {};

  constructor(public commonService: CommonService,
              public utilService: UtilService,
              public authService: AuthService,
              public billingReportsService: BillingReportsService,
              public commonBillingService: CommonBillingService
              ) {
    super();
  }

  ngOnInit() {
    this.getEtsData();
    this.getLastUploadedFile();
  }

  getConfigs() {
    this.isLoading = true;
    this.commonService.fetchConfig().subscribe((response: any) => {
      this.config = this.commonService.getConfigForElementKey(response, 'Billing Reports Page');
      this.setDateFilters();
      this.setFilterConfigs();
      this.isLoading = false;
    });
  }

  getEtsData() {
    this.commonService.getEtsData().subscribe((response) => {
      this.vendors = response.vendors;
      this.createVendorMap();
      this.cabs = response.cabs;
      this.offices = response.offices;
      this.costCenters = response.costCenters;
      this.getConfigs();
      this.setAllOptionToData();
    });
  }

  createVendorMap() {
    this.vendors.forEach((vendor) => {
      this.vendorMap[vendor.guid] = vendor.vendorName;
    });
  }

  getVendorValue(option) {
    return option.guid;
  }

  getVendorLabel(option) {
    return option.vendorName;
  }

  setAllOptionToData() {
    this.vendorOptions = Object.assign([], this.vendors);
    this.costCenterOptions = Object.assign([], this.costCenters);
    this.officesOptions = Object.assign([], this.offices);

    this.vendorOptions.push({
      vendorName: 'All'
    });
    this.costCenterOptions.push({
      name: 'All'
    });
    this.officesOptions.push({
      address: 'All'
    });
  }

  setDateFilters() {
    this.dateSectionConfig = this.commonService.getConfigForElementKey(this.config, 'Date Section');

    const startDateConfig = this.commonService.getConfigForElementKey(this.dateSectionConfig, 'Start Date').config.defaultValue;
    const endDateConfig = this.commonService.getConfigForElementKey(this.dateSectionConfig, 'End Date').config.defaultValue;

    this.startDate = this.utilService.getMoment().add(Number(startDateConfig), 'days');
    this.endDate = this.utilService.getMoment().add(Number(endDateConfig), 'days');
    this.inputControlStartDate = new FormControl([this.startDate]);
    this.inputControlEndDate = new FormControl([this.endDate]);

    this.dateMaxConfig = {
      minDate: '',
      maxDate: this.utilService.getMoment(),
      startDate: this.startDate,
      endDate: this.endDate,
    };
  }

  setFilterConfigs() {
    this.formDetails = new FormGroup({});
    const filterConfigAllData = this.commonService.getConfigForElementKey(this.config, 'Filter Section');
    this.filterSectionConfig = filterConfigAllData;
    this.configToValueMap = {};

    for (const configData of filterConfigAllData.elementConfigList) {
      this.filterElementConfig[configData.elementKey] = configData.config;
      if (configData.elementKey === 'Select Vendor' && this.filterElementConfig[configData.elementKey].values.length === 0) {
        const values = [];
        this.vendors.map((vendor) => {
          values.push({name: vendor.vendorName, guid: vendor.guid});
        });
        this.filterElementConfig[configData.elementKey].values = values;
      }
      if (configData.elementKey === 'Select Office' && this.filterElementConfig[configData.elementKey].values.length === 0) {
        const values = [];
        this.offices.map((office) => {
          values.push(office.address);
        });
        this.filterElementConfig[configData.elementKey].values = values;
      }
      if (configData.elementKey === 'Cost Center' && this.filterElementConfig[configData.elementKey].values.length === 0) {
        const values = [];
        this.costCenters.map((center) => {
          values.push(center.name);
        });
        this.filterElementConfig[configData.elementKey].values = values;
      }
      this.formDetails.setControl(configData.elementKey, new FormControl());

      if (configData.config.visibility.elementKey) {
        const key = configData.config.visibility.elementValue[0];
        const value = configData.elementKey;
        this.configToValueMap[key] = value;
      }
    }
  }

  onStartDateChange(dateValue: any) {
    this.startDate = dateValue.next[0];
    if (this.endDate && this.startDate.isAfter(this.endDate, 'day')) {
      this.setDateFormControlError();
      this.displayInvalidDateMessage = 'Invalid date range';
    } else if (this.endDate && this.endDate.diff(this.startDate, 'days') > 31) {
      this.setDateFormControlError();
      this.displayInvalidDateMessage = 'Selected dates exceed the limit of 31 days';
    } else {
      this.removeFormControlError();
    }
  }

  setDateFormControlError() {
    this.inputControlStartDate.setErrors({incorrectStartDate: true});
    this.inputControlEndDate.setErrors({incorrectEndDate: true});
    this.displayInvalidDateError = true;
  }

  removeFormControlError() {
    this.inputControlEndDate.setErrors(null);
    this.inputControlStartDate.setErrors(null);
    this.displayInvalidDateError = false;
    this.displayInvalidDateMessage = '';
  }

  onEndDateChange(dateValue: any) {
    this.endDate = dateValue.next[0];
    if (this.startDate && this.endDate.isBefore(this.startDate, 'day')) {
      this.setDateFormControlError();
      this.displayInvalidDateMessage = 'Invalid date range';
    } else if (this.startDate && this.endDate.diff(this.startDate, 'days') > 31) {
      this.setDateFormControlError();
      this.displayInvalidDateMessage = 'Selected dates exceed the limit of 31 days';
    } else {
      this.removeFormControlError();
    }
  }

  selectedDate(event) {
    this.startDate = event.date.startDate ? parseZone(event.date.startDate, 'DD/MM/YYYY') : '';
    this.endDate = event.date.endDate ? parseZone(event.date.endDate, 'DD/MM/YYYY') :  '';
    /*     "1 => " + this.endDate.isBefore(this.startDate, 'day'),
    "2 => " + this.endDate.diff(this.startDate, 'days'),
    "3 => " + this.startDate.isAfter(this.endDate, 'day'),
    "4 => " + this.endDate.diff(this.startDate, 'days')); */
    if (this.startDate && this.endDate.isBefore(this.startDate, 'day')) {
      // this.setDateFormControlError();
      this.displayInvalidDateMessage = 'Invalid date range';
    } else if (this.startDate && this.endDate.diff(this.startDate, 'days') > 31) {
      // this.setDateFormControlError();
      this.displayInvalidDateMessage = 'Selected dates exceed the limit of 31 days';
    } else if (this.endDate && this.startDate.isAfter(this.endDate, 'day')) {
      // this.setDateFormControlError();
      this.displayInvalidDateMessage = 'Invalid date range';
    } else if (this.endDate && this.endDate.diff(this.startDate, 'days') > 31) {
      // this.setDateFormControlError();
      this.displayInvalidDateMessage = 'Selected dates exceed the limit of 31 days';
    }
    else {
      this.displayInvalidDateMessage = '';
      // this.removeFormControlError();
    }
  }

  private checkVendorManagerRole(): boolean {
    const vendorRoles = ["VENDOR_MANAGER", "VENDOR_BILLING_MANAGER", "PLATFORM_VENDOR_BILLING_MANAGER", "VENDOR_RISK_MANAGER"];
    const found = vendorRoles.findIndex((role) => {
      return this.authService.user.role === role;
    });

    return found !== -1;
  }

  getBillingReportDTO() {
    const optionType = this.formDetails.get('Select Option').value ? this.formDetails.get('Select Option').value : 'All';
    const optionValueKey = this.configToValueMap[optionType];
    const optionValue = this.formDetails.get(optionValueKey) ? this.formDetails.get(optionValueKey).value : ['All'];
    const buid =  this.authService.user.buId;
    const empGuid = this.authService.user.employeeGuid;
    const client = this.authService.client.client;

    const vendorType = this.checkVendorManagerRole();
    const reportDTO = {
      optionType,
      optionValue,
      buid,
      empGuid,
      vendorType,
      client
    };
    return reportDTO;
  }

  handleDownloadBillingReport() {
    if (!this.displayInvalidDateMessage) {
      this.isLoading = true;
      const searchQuery = {
        startDate: this.startDate.format('DD-MM-YYYY'),
        endDate: this.endDate.format('DD-MM-YYYY'),
      };
      const request = {
        billingReportDTO: this.getBillingReportDTO()
      };
      this.billingReportsService.fetchRawBillingReport(request, searchQuery).subscribe((response: any) => {
        this.isLoading = false;
        this.commonBillingService.downloadBlob(response);
      }, () => {
        this.isLoading = false;
        this.showErrorDialog = true;
        this.errorMessage = 'Download failed.';
      });
    }
  }

  dismissError() {
    this.showErrorDialog = false;
    this.errorMessage = '';
  }

  handleDownloadTripReport() {
    if (!this.displayInvalidDateMessage) {
      this.isLoading = true;

      const searchQuery = {
        startDate: this.startDate.format('DD-MM-YYYY'),
        endDate: this.endDate.format('DD-MM-YYYY'),
        loggedInEmail : this.authService.user.loginEmpId=='undefined' ? "" : this.authService.user.loginEmpId 
      };
      this.billingReportsService.fetchTripAmountReport(this.getBillingReportDTO(), searchQuery).subscribe((response: any) => {
        this.isLoading = false;
        const regexPattern = /"((?:\\.|[^"\\])*)"/;
        const extractedmsg = response.message.match(regexPattern);
        this.successMessage = extractedmsg[1];
        this.showSuccessToast = true;
      }, (error) => {
        this.isLoading = false;
        this.showErrorDialog = true;
        this.errorMessage = error.error.message;
      });
    }
  }

  toggleToastBillRepost() {
    this.showSuccessToast = false;
  }

  handleUploadReport(files: any) {
    this.fileToUpload = files.item(0);
    this.fileName = this.fileToUpload.name;
    this.showFileUploadModal = true;
    this.submitUploadReport();
  }

  handleDismissUploadFileModal() {
    this.fileToUpload = null;
    this.fileName = '';
    this.showFileUploadModal = false;
    this.uploadFileError = '';
  }

  submitUploadReport() {
    if (!this.displayInvalidDateMessage) {
      // this.isLoading = true;
      const searchQuery = {
        modifierGuid: this.authService.user.employeeGuid,
        modifierBuid: this.authService.user.buId,
        vendor: this.checkVendorManagerRole(),
        client: this.authService.client.client,
      };
      const uploadFile = {uploadFile: this.fileToUpload };
      this.billingReportsService.uploadBillingReport(uploadFile, searchQuery).subscribe((event: any) => {
        if (event.type === HttpEventType.Response) {
          // this.isLoading = false;
          this.showFileUploadModal = false;
          this.fileToUpload = null;
          this.fileName = '';
          this.uploadFileError = '';
          if (event.body.errorDTO.length > 0) {
            this.showFileErrors = true;
            this.failedRows = event.body.errorDTO;
          } else {
            this.showUploadSuccess = true;
          }
          this.getLastUploadedFile();
        }
      }, (data) => {
        // this.isLoading = false;
        this.showFileUploadModal = false;
        this.uploadFileError = data.error.message || 'Upload failed!';
      });
    }
  }

  dismissFileError() {
    this.showFileErrors = false;
  }

  handleDownloadTemplate() {
    if (!this.displayInvalidDateMessage) {
      this.isLoading = true;
      this.billingReportsService.fetchBillingTemplate().subscribe((response: any) => {
        this.isLoading = false;
        this.commonBillingService.downloadBlob(response);
      }, () => {
        this.isLoading = false;
        this.showErrorDialog = true;
        this.errorMessage = 'Download failed.';
      });
    }
  }

  toggleToast() {
    this.showUploadSuccess = false;
  }

  getLastUploadedFile() {
    const searchQuery = {
      empGuid: this.authService.user.employeeGuid,
      buid: this.authService.user.buId,
      client: this.authService.client.client,
    };
    this.billingReportsService.fetchLastUploadedFile(searchQuery).
    subscribe((response: any) => {
      this.lastUploadedFile = response;
      this.getFileName(response);
    });
  }

  getFileName(data) {
    const headerContent = data.headers.get('content-disposition');
    if (headerContent){
      const index = headerContent.lastIndexOf('filename');
      this.lastUploadedFileName = headerContent.substr(index + 9);
    }

  }

  handleDownloadFile() {
    this.commonBillingService.downloadBlob(this.lastUploadedFile);
  }
}
